import { faCheckCircle, faCircleExclamation, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import { PIPELINE_DELETE_CDD } from "../../../../config/config";

interface DeleteCddProps {
    cip_id : number;
    cdd_name : string;
    showModal : (oncloseVal : boolean)=>void
}

const DeleteCdd : React.FC<DeleteCddProps> = ({cip_id, cdd_name, showModal}) => {
    const [isDeleted, setDeleted] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const handleDelete = async() => {
        setLoading(true);
        try{
            await api.delete(PIPELINE_DELETE_CDD+cip_id, {
                headers : {'Authorization' : 'Bearer '+getToken()}
            })
            setDeleted(true);
        }catch(e){
            alert('Failed to remove candidate.');
            setLoading(false);
        }
    }

    return(
        <div className="min-w-[25rem] flex flex-col gap-4">
            {!isDeleted ? (
                <>
                    <div className="flex gap-2 justify-center items-center">
                        <FontAwesomeIcon className="text-rose-400" icon={faCircleExclamation} />
                        <h2 className="font-bold text-gray-600 uppercase">Remove {cdd_name} from the pipeline?</h2>
                    </div>
                    <div className="flex gap-3 justify-end">
                        {loading ? (
                            <div>
                                <button type="button" className="button button-red bg-red-400 hover:bg-red-400 cursor-not-allowed text-sm">
                                    <FontAwesomeIcon icon={faSpinner} className="animate-spin" /> &nbsp;
                                    Removing candidate....
                                </button>
                            </div>
                        ) : (
                            <div className="flex gap-2">
                                <button type="button" onClick={()=>showModal(false)} className="button button-vcc-yellow text-sm">Cancel</button>
                                <button type="button" onClick={handleDelete} className="button button-red text-sm">Delete</button>
                            </div>
                        )}
                    </div>
                </>
            ) : (
                <div className="flex flex-col gap-4">
                    <div className="flex justify-center items-center my-4 font-semibold uppercase gap-2">
                        <FontAwesomeIcon className="text-green-500" icon={faCheckCircle}  />
                        <h2 className="text-gray-600">Candidate {cdd_name} has been removed from the pipe.</h2>
                    </div>
                    <div className="ms-auto">
                        <button type="button" onClick={()=>showModal(false)} className="button button-vcc-yellow text-sm">Close</button>
                    </div>
                </div>
            )}

        </div>
    )
}

export default DeleteCdd;